import FingerprintJS from '@fingerprintjs/fingerprintjs';
// import * as FingerprintJSPro from '@fingerprintjs/fingerprintjs-pro';
import { getCurrentBrowserFingerPrint } from "@rajesh896/broprint.js";
import { isNil } from "lodash-es";
import { withTimeout } from '../analytics/utils';
import { setCookie } from './utils';

const initializeFingerprintV3 = () => FingerprintJS.load({ monitoring: false })
// const initializeFingerprintPro = () => FingerprintJSPro.load({ apiKey: "QEGQ6DM4ANqUBcl1o5Jp", region: "ap" })
const generateV0Fp = async () => {
    const fp = await getCurrentBrowserFingerPrint()
    return !isNil(fp) ? String(fp) : fp
}

const getFingerPrintV0 = async () => {
    try {
        let fp = window.localStorage.getItem("ttClientFpV0")
        if (isNil(fp)) {
            fp = await generateV0Fp()
        }
        return { "ttClientFpV0": fp }
    } catch (err) {
        // log to sentry
    }
    return {}
};

const getFingerPrintV3 = async () => {
    try {
        const result = JSON.parse(
            window.localStorage.getItem("fingerPrintV3") || "{}"
        )
        const fp = result.visitorId
        setCookie("__tt_client_fp", fp, 30);
        return { "ttClientFp": fp }
    } catch (err) {
        // log to sentry
    }
    return {}
}

// const getFingerPrintPro = async () => {
//     try {
//         const result = JSON.parse(
//             window.localStorage.getItem("fingerPrintPro") || "{}"
//         )
//         const fp = result.visitorId
//         return { "ttClientFpPro": fp }
//     } catch (err) {
//         // log to sentry
//     }
//     return {}
// }

const getBrowserFingerPrint = async () => {
    const data = await Promise.allSettled([
        withTimeout<{}>(
            getFingerPrintV0(), {
            message: 'getFingerPrintV0 timeout',
            duration: 500,
        }),
        withTimeout<{}>(
            getFingerPrintV3(), {
            message: 'getFingerPrintV3 timeout',
            duration: 500,
        }),
        // withTimeout<{}>(
        //     getFingerPrintPro(), {
        //     message: 'getFingerPrintPro timeout',
        //     duration: 500,
        // }),
    ])

    return Object.assign(
        {},
        ...data.map((prom) => prom.status === "fulfilled" ? prom.value : {})
    );
}

export {
    generateV0Fp,
    getBrowserFingerPrint,
    // initializeFingerprintPro,
    initializeFingerprintV3
};

